var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0154 17.05L10.2615 11.2961C9.76152 11.7089 9.18652 12.032 8.53652 12.2653C7.88652 12.4987 7.21409 12.6153 6.51922 12.6153C4.81005 12.6153 3.36354 12.0236 2.17967 10.84C0.995803 9.65643 0.40387 8.21028 0.40387 6.50157C0.40387 4.79283 0.995653 3.34616 2.17922 2.16154C3.36279 0.976944 4.80894 0.384644 6.51767 0.384644C8.22639 0.384644 9.67305 0.976577 10.8577 2.16044C12.0423 3.34431 12.6346 4.79083 12.6346 6.49999C12.6346 7.21409 12.5147 7.89614 12.275 8.54614C12.0352 9.19614 11.7153 9.76153 11.3153 10.2423L17.0942 16.0211C17.2327 16.1569 17.3019 16.3236 17.3019 16.521C17.3019 16.7185 17.2236 16.8956 17.0671 17.0521C16.9236 17.1955 16.7487 17.2673 16.5423 17.2673C16.3359 17.2673 16.1603 17.1948 16.0154 17.05ZM6.51922 11.1154C7.80769 11.1154 8.89904 10.6683 9.79327 9.77404C10.6875 8.87981 11.1346 7.78846 11.1346 6.49999C11.1346 5.21153 10.6875 4.12018 9.79327 3.22594C8.89904 2.33171 7.80769 1.88459 6.51922 1.88459C5.23075 1.88459 4.1394 2.33171 3.24517 3.22594C2.35095 4.12018 1.90384 5.21153 1.90384 6.49999C1.90384 7.78846 2.35095 8.87981 3.24517 9.77404C4.1394 10.6683 5.23075 11.1154 6.51922 11.1154Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.80b2f070fcfbd3e08774cd889b27eb84.svg";
export { ForwardRef as ReactComponent };